import React from 'react';

export const SpacerIcon = ({ width = 32, height = 32, color = '#BFBFBF' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill={color} d="M9 16h14v1H9z" />
  </svg>
);
